import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddFields,
  setExtraFieldsData,
  setGuestDetailsData,
  setGuestFields,
  setIsBackToHoreca,
  setQuantities,
  setSelectedExtraProduct,
  setTotalPriceInclusiveVAT,
  setTotalVAT,
  setTransactionDetails,
} from "../../store/slice/Ticketing.slice";
import {
  CircularProgress,
  StepConnector,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ConfirmandPay from "./ConfirmandPay";
import { useNavigate } from "react-router-dom";
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import ArrowForwardIosTwoToneIcon from "@mui/icons-material/ArrowForwardIosTwoTone";
import ArrowBackIosTwoToneIcon from "@mui/icons-material/ArrowBackIosTwoTone";
import {
  getExtraFieldDetails,
  getGuestDetails,
  transactionCostForReservation,
} from "../../api/HorecaWidget.service";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Snackbar from "@mui/material/Snackbar";
import dayjs from "dayjs";
import { CreateTicketingReservation } from "../../api/ticketing.service";
import { format_Number } from "../../utils/utils";
import Combination from "../Component/Combination";
import UpsaleProduct from "../Component/UpsaleProduct";
import UserDetailsSection from "../Component/UserDetailSection";
dayjs?.extend(customParseFormat); // Extend for custom date format parsing

const DottedStepConnector = (props) => (
  <StepConnector
    {...props}
    sx={{
      "& .MuiStepConnector-line": {
        borderColor: "#000000", // Line color
        borderStyle: "dashed", // Dashed line style (simulates dotted with spacing)
        borderWidth: 1, // Line thickness
      },
    }}
  />
);

export default function BookNowForm() {
  const { combinationList,combinationQTY } = useSelector((store) => store.Activity);
  const {
    reservType,
    GuestDetailsData,
    extraProductData,
    quantities,
    selectedDate,
    time,
    totalCount,
    selectedExtraProduct,
    transactionDetails,
    guestFields,
    addFields,
    languageWords,
    defaultLanguage,
    extraFieldsData,
    SelectedEventOrStdResType,
    TotalPrice,
    TotalPriceInclusiveVATs,
    TotalVAT,
    selectedCombination,
    guestCounts
  } = useSelector((store) => store.Ticketing);
  const { languageData } = useSelector((store) => store?.widgetSettings);
  const{defaultLang}=useSelector((store) => store?.Combination)
  const [steps, setSteps] = React.useState([
    languageWords?.Availability,
    languageWords?.ExtraProducts,
    languageWords?.combinations,
    languageWords?.yourDetails,
    languageWords?.ConfirmandPay,
  ]);

  const [isLoading, setIsLoading] = React.useState(false);
  const theme = useTheme();
  const {
    WidgetSetting,
    key,
    floating,
    widgetConfig,
  } = useSelector((store) => store?.widgetSettings);
  const reservationRequestMin =
    parseInt(
      WidgetSetting?.find((item) => item?.tag === "reservationRequest")
    ) ?? 0;
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = React.useState(1);
  const [completed, setCompleted] = React.useState({ 0: false });
  const { isBookNowOpen } = useSelector((store) => store.addGuest);
  const dispatch = useDispatch();
  const totalSteps = () => steps.length;
  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "right",
  });
  const { vertical, horizontal, open } = state;
  const handleClosebar = () => {
    setState({ ...state, open: true });

    setTimeout(() => {
      setState({ ...state, open: false });
    }, 5000);
  };
  const completedSteps = () => Object.keys(completed).length;
  const isLastStep = () => activeStep === totalSteps() - 1;
  const allStepsCompleted = () => completedSteps() === totalSteps();
  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };
  const handleBack = () => {
    if (activeStep == 1) {
      dispatch(setIsBackToHoreca(true));
      navigate(-1);
      return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };



  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const VAT_PERCENT_PRODUCTS=SelectedEventOrStdResType?.vat;
  const VAT_TOTAL_PRODUCTS=(TotalPrice-(TotalPrice/(1+(VAT_PERCENT_PRODUCTS/100))));
  const VAT_TOTAL_EXTRA=selectedExtraProduct?.reduce((acc,product)=>{
    return acc+ ((product?.price-(product?.price/(1+(product?.vat/100)))))
  },0);
  const VAT_TOTAL_TRANSACTION_COST=((transactionDetails?.pricePerReservation-(transactionDetails?.pricePerReservation/(1+(transactionDetails?.vat/100))))*1) || 0
  const TOTAL_VAT=(VAT_TOTAL_PRODUCTS+VAT_TOTAL_EXTRA+VAT_TOTAL_TRANSACTION_COST).toFixed(2);
  const totalSum = selectedExtraProduct?.reduce((acc, product) => {
    return acc + (product.quantity * product.price);
}, 0);
const totalCombination=selectedCombination?.reduce((acc,product)=> acc+ product?.price,0)
 const TOTAL_INCLUSIVE_VAT= TotalPrice + totalSum + transactionDetails?.pricePerReservation + totalCombination
React.useEffect(()=>{
  dispatch(setTotalVAT(TOTAL_VAT))
  dispatch(setTotalPriceInclusiveVAT(TOTAL_INCLUSIVE_VAT))
},[])



  const fetchGuestDetails = async () => {
    try {
      const response = await getGuestDetails(
        key,
        SelectedEventOrStdResType?.idreservationtype,
        defaultLang ? defaultLang :defaultLanguage
      );
      if (response?.status != 200 || !response?.data) {
        console.error("Failed to fetch guest details:", response);
        return;
      }
      dispatch(setGuestDetailsData(response?.data));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchExtraFieldDetails = async () => {
    try {
      const response = await getExtraFieldDetails(
        SelectedEventOrStdResType?.idreservationtype,
       defaultLang ? defaultLang :  defaultLanguage,
        key
      );
      dispatch(setExtraFieldsData(response));
    } catch (error) {
      console.error(error);
    }
  };
  const creatBookingReservation = async () => {
    setIsLoading(true);
    const guestPayload=guestFields.reduce((acc, item) => {
      const key = item.idfield.replace(/{|}/g, ""); // Remove curly braces
      acc[key] = item.data;
      return acc;
  }, {});
    const combinationInfoPayload = selectedCombination?.map((item) => {
      let count =combinationQTY[item?.idreservationtype + String(item.isBefore)]
      return {
        idreservationtype: item?.idreservationtype,
        ArrivalDate: reservType?.isStandardTicket ? selectedDate : selectedDate?.availableDate,
        DepartureDate: reservType?.isStandardTicket ? selectedDate : selectedDate?.availableDate,
        ArrivalTime: item?.arrivalTime,
        DepartureTime: item?.depatureTime,
        ReservationLocations:item?.tables?.slice(0,count)?.map((table) => ({
          idtables: table?.idtables,
          ArrivalDate: reservType?.isStandardTicket ? selectedDate : selectedDate?.availableDate,
          DepartureDate: reservType?.isStandardTicket ? selectedDate : selectedDate?.availableDate,
          ArrivalTime: item?.arrivalTime,
          DepartureTime: item?.depatureTime,
        })),
        MainModuleId: 1,
        Guests: [guestPayload],
        numberOfGuest: totalCount,
        LanguageCode: defaultLanguage
      };
    });
    const payload = {
      Key: key,
      kioskMode:widgetConfig?.settings?.kioskMode,
      TicketingReservation: {
      TicketingReservationId:0, 
      TicketId:parseInt(reservType?.eventTicketId),
      IsStandardTicket:reservType?.isStandardTicket,
      TicketDate:reservType?.isStandardTicket ? selectedDate : selectedDate?.availableDate,
      idreservationtype:SelectedEventOrStdResType?.idreservationtype,
      NoCustomerInfoRequired:false,
      idlanguage: parseInt(languageData?.find((item)=> item?.langcode == defaultLanguage)?.idlanguage),
      EventTicketQty:reservType?.isStandardTicket ? 0 : totalCount,
      Field1:reservType?.isStandardTicket ? guestCounts[SelectedEventOrStdResType?.idreservationtype]?.adult : 0,
      Field2:reservType?.isStandardTicket ? guestCounts[SelectedEventOrStdResType?.idreservationtype]?.child : 0,
      Field3:reservType?.isStandardTicket ? guestCounts[SelectedEventOrStdResType?.idreservationtype]?.kid : 0,
      Field4:reservType?.isStandardTicket ? guestCounts[SelectedEventOrStdResType?.idreservationtype]?.baby : 0,
      Field5:reservType?.isStandardTicket ? guestCounts[SelectedEventOrStdResType?.idreservationtype]?.toddler : 0,
      idstatussetup:0,
      IsCancelled:false,
      IsPaymentDone:false,       
      TicketingUpsaleProducts:[],
      // Info: "test",
      NameOnReservation: "widget",
      PaymentAmount: TotalPriceInclusiveVATs,
      VATAmount: parseFloat(TotalVAT),
      AdoptedBy: "widget",
      NoCustomerInfoRequired: false,
      IsEmailRequired: false,
      TicketingUpsaleProducts: selectedExtraProduct?.map((item)=>({
        UpsaleProductId:item?.idproduct,
        ProductPrice:item?.price,
        Qty:item?.quantity
      })),
      TicketingTransactionCosts: [
        {
          TransactionProductId: transactionDetails?.idproduct,
          Price: transactionDetails?.pricePerReservation,
      //    TicketingReservation:{}
        },
      ],
      TicketingEventProducts: !reservType?.isStandardTicket ? [
        {
          EventProductId:parseInt(SelectedEventOrStdResType?.productId),
          ProductPrice:parseInt(SelectedEventOrStdResType?.eventProductPrice)
        }
      ] : [],
      TicketingGuestFields: [...guestFields] || [],
      TicketingReservationFields: addFields ,
      TicketingDayPriceProducts: reservType?.isStandardTicket ? [
        {
          EventProductId: parseInt(SelectedEventOrStdResType?.productId),
          Price1: SelectedEventOrStdResType?.dayProductPrice1,
          Price2: SelectedEventOrStdResType?.dayProductPrice2,
          Price3: SelectedEventOrStdResType?.dayProductPrice3,
          Price4: SelectedEventOrStdResType?.dayProductPrice4,
          Price5: SelectedEventOrStdResType?.dayProductPrice5,
          TicketingReservation:{}
        },
       
      ] : [],
      PayCash: false,
      PayTerminal: true,
      PayOther: false,
      CombinationInfo:combinationInfoPayload
      
      }
    };

    try {
      const response = await CreateTicketingReservation(payload);
      
      if (response?.status == 'open') {
        window.parent.postMessage(
          {
            redirectUrl: `${response?._links?.checkout?.href}`,
          },
          "*"
        );
        // window.location = response._links.checkout.href;
      }
      else {
        console.error("Failed to create booking reservation:", response);
        handleClosebar();
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const fetchTransactionDetails = async () => {
    try {
      const response = await transactionCostForReservation(
        key,
        SelectedEventOrStdResType?.idreservationtype,
        defaultLang ? defaultLang : defaultLanguage
      );
      if (response?.status != 200 || !response?.data) {
       console.info("transaction details not found")
      }
      dispatch(setTransactionDetails(response?.data));
    } catch (error) {
      console.log("error in transaction cost:", error?.message);
      throw new Error(error?.message);
    }
  };

  const createInitialValuesAndValidationSchema = (
    guestData,
    extraData,
    widgetConfig
  ) => {
    const initialValues = {};
    const validationShape = {};
  
    const processFieldData = (
      field,
      languageType,
      customLink,
      shouldApplyValidation
    ) => {
      let languageData = field[languageType]?.find(
        (f) => f?.fieldname == "name"
      )?.data;
  
      if (customLink) {
        languageData = "Link";
      } else if (field?.type == "textarea") {
        if (typeof field[languageType]?.[0]?.data === "string") {
          languageData = field[languageType]
            ?.find((f) => f?.fieldname == "name")
            ?.data?.replace(".", "");
        } else {
          languageData = field[languageType]?.find(
            (f) => f?.fieldname == "name"
          )?.data;
        }
      }
  
      if (!languageData) return; // Skip if no valid name is found
  
      if (field?.type == "checkboxList") {
        initialValues[languageData] = [];
      } else {
        initialValues[languageData] = "";
      }
  
      let validationRule;
  
      // Skip validation for 'label' and 'link' types
      if (field?.type === "label" || field?.type === "link") {
        

        validationRule = Yup.mixed().notRequired();  // No validation for these fields
      } else if (field.tag === "{email}") {
        validationRule = Yup.string().email("Invalid email format");
      } else if (field.tag === "{phone}") {
        validationRule = Yup.string().matches(
          /^\+?\d{1,3}\s*\(?\d{1,4}?\)?[\s.-]?\d{1,4}[\s.-]?\d{1,4}[\s.-]?\d{1,9}$/,
          "Invalid phone number format"
        );
        
      }
      else if (field?.type === 'termsandcondition') {
        validationRule = Yup.boolean()
          .oneOf([true], 'You must accept the terms and conditions');
      }
       else if (field?.type == "checkboxList") {
        validationRule = Yup.array().of(Yup.string());
      } else {
        validationRule = Yup.string();
      }
  
      // Apply `.required("Required")` **only for guestData** when `!widgetConfig?.token && field.required`
      if ((shouldApplyValidation && field.required) && (field?.type !== "label" && field?.type !== "link")) {
        validationRule = validationRule.required("Required");
      }
      validationShape[languageData] = validationRule;
    };
  
    guestData?.forEach((field) =>
      processFieldData(
        field,
        "guestLanguages",
        field.type == "link",
        !widgetConfig?.token
      )
    );
  
    extraData?.forEach(
      (field) =>
        processFieldData(field, "fieldsLanguages", field.type == "link", true) // ExtraData should never enforce required validation
    );
  
  
  
    return {
      initialValues,
      validationSchema: Yup.object().shape(validationShape),
    };
  };
  
  // Call the function with widgetConfig
  const { initialValues, validationSchema } =
    createInitialValuesAndValidationSchema(GuestDetailsData, extraFieldsData, widgetConfig);


  React.useEffect(() => {
    fetchGuestDetails();
    fetchTransactionDetails();
    fetchExtraFieldDetails();
  }, []);

  // create a React.userEffect that listens to the dom changes and passes a console.log of the number of changes in the dom
  const send = (
    frameHeight,
    frameWidth,
    top,
    right,
    bottom,
    left,
    floating,
    redirectUrl
  ) => {
    window.parent.postMessage(
      {
        reservationIframeHeight: frameHeight,
        reservationIframeWidth: frameWidth,
        reservationIframePositionTop: top,
        reservationIframePositionRight: right,
        reservationIframePositionBottom: bottom,
        reservationIframePositionLeft: left,
        reservationIframePositionFloating: floating,
        redirectUrl: redirectUrl,
      },
      "*"
    );
  };
  const getHeight = () => {
    let height = setTimeout(() => {
      let rootHeight = document.getElementsByClassName("MuiBox-root")[1];
      let frameHeight = 0;
      if (rootHeight) {
        frameHeight = rootHeight.clientHeight + 50;
      }

      send(
        frameHeight + "px",
        "100%",
        "",
        "0px",
        "0px",
        "",
        widgetConfig?.settings?.floatButtonActive
      );
    }, 100);
  };

  React.useEffect(() => {
    const targetNode = document.body;
    const config = { attributes: true, childList: true, subtree: true };

    const callback = (mutationsList) => {
      if (floating == "relative") {
        getHeight();
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

    return () => {
      observer.disconnect();
    };
  }, []);

  React.useEffect(() => {
    if (extraProductData?.length == 0 && combinationList.length == 0) {
      setSteps([
        languageWords?.Availability,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    } else if (extraProductData?.length == 0 && combinationList.length > 0) {
      setSteps([
        languageWords?.Availability,
        languageWords?.combinations,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    }
  }, [extraProductData]);

  React.useEffect(() => {
    document.body.setAttribute(
      "style",
      "background-color: " + theme?.widget?.stepScreenBgColor + " !important"
    ); // theme?.widget?.stepScreenBgColor;
    if (combinationList.length == 0 && extraProductData?.length == 0) {
      setSteps([
        languageWords?.Availability,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    } else if (combinationList.length == 0 && extraProductData?.length != 0) {
      setSteps([
        languageWords?.Availability,
        languageWords?.ExtraProducts,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    }
  }, [combinationList]);

  React.useEffect(() => {
    if (totalCount >= widgetConfig?.reservationRequestMin) {
      setSteps([
        languageWords?.Availability,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    }
  }, [totalCount]);
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          // Ensure that form is valid before calling creatBookingReservation
        }}
      >
        {({
          values,
          handleChange,
          handleSubmit,
          touched,
          errors,
          dirty,
          setFieldTouched,
          setFieldValue,
        }) => (
          <Box
            sx={{
              backgroundColor: theme?.widget?.stepScreenBgColor,
              height: "100vh",
              p: 1,
            }}
          >
            <Box
              sx={{
                backgroundColor: theme?.widget?.stepScreenBgColor,
              }}
            >
              <Box
                sx={{
                  width: "100%", // Take full width
                  overflow: "hidden", // Prevent overflow
                  px: 2,
                  mb: 5,
                }}
              >
                <Stepper
                  nonLinear
                  activeStep={activeStep}
                  connector={<DottedStepConnector />}
                  sx={{
                    mt: 1,
                    flexWrap: { xs: "wrap", sm: "nowrap" }, // Wrap steps on small screens
                    justifyContent: { xs: "center", sm: "flex-start" }, // Center on xs and align to start on sm+
                  }}
                >
                  {steps.map((label, index) => (
                    <Step key={label} completed={completed[index]}>
                      <StepButton
                        sx={{
                          ...(activeStep === index && {
                            "& .MuiStepLabel-label": {
                              color:
                                activeStep === index
                                  ? theme?.widget?.stepTextColorActive
                                  : theme?.widget?.stepTextColor,
                              fontWeight: "bold",
                              fontSize: "15px",
                            },
                            "& .MuiStepIcon-root": {
                              color:
                                activeStep === index
                                  ? theme?.widget?.stepCircleBgColor
                                  : theme?.widget?.stepCircleActiveBg,
                              borderRadius: "50%",
                              // Adding the following line for custom icon text color when active
                              "& .MuiStepIcon-text": {
                                fill:
                                  activeStep === index
                                    ? theme?.widget?.stepCircleTextActive
                                    : theme?.widget?.stepCircleTextColor,
                              },
                            },
                          }),
                          width: { xs: "100%", sm: "auto" },
                          fontSize: { xs: "12px", sm: "inherit" },
                        }}
                        // onClick={handleStep(index)}
                        disabled={true}
                      >
                        {isSmallScreen ? "" : label}
                      </StepButton>
                    </Step>
                  ))}
                </Stepper>
              </Box>
              <div>
                {allStepsCompleted() ? (
                  <React.Fragment>
                    <Typography sx={{ mt: 2, mb: 1 }}>
                      All steps completed - you're finished
                    </Typography>
                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                      <Box sx={{ flex: "1 1 auto" }} />
                      <Button onClick={handleReset}>Reset</Button>
                    </Box>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Box>
                      {(() => {
                        switch (steps[activeStep]) {
                          case languageWords?.Availability:
                            navigate(-1, {
                              state: { openWidgetScreen: true },
                            });
                            break;

                          case languageWords?.ExtraProducts:
                           return (
                            <UpsaleProduct
                            selectedExtraProduct={selectedExtraProduct}
                            extraProductData={extraProductData}
                            quantities={quantities}
                            selectedCombination={selectedCombination}
                            totalCount={totalCount}
                            languageWords={languageWords}
                            reservType={{...SelectedEventOrStdResType,...reservType}}
                            selectedDate={selectedDate}
                            adult={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.adult}
                            child={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.child}
                            kid={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.kid}
                            baby={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.baby}
                            toddler={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.toddler}
                            time={time}
                            transactionDetails={transactionDetails}
                            transactionPrice={
                              transactionDetails?.pricePerReservation
                            }
                            excludingVat={TOTAL_INCLUSIVE_VAT - TOTAL_VAT- transactionDetails?.pricePerReservation}
                            totalVat={TOTAL_VAT}
                            totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                            totalCostYourBooking={TotalPrice + totalSum}
                            setQuantities={setQuantities}
                            setSelectedExtraProduct={setSelectedExtraProduct}
                            />
                           )

                          case languageWords?.combinations:
                            return (
                            <Combination
                            totalCount={totalCount}
                            languageWords={languageWords}
                            reservType={{...SelectedEventOrStdResType,...reservType}}
                            selectedDate={selectedDate}
                            time={time}
                            adult={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.adult}
                            child={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.child}
                            kid={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.kid}
                            baby={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.baby}
                            toddler={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.toddler}
                            selectedExtraProduct={selectedExtraProduct}
                            transactionDetails={transactionDetails}
                            transactionPrice={
                              transactionDetails?.pricePerReservation
                            }
                            excludingVat={TOTAL_INCLUSIVE_VAT - TOTAL_VAT- transactionDetails?.pricePerReservation}
                            totalVat={TOTAL_VAT}
                            totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                            totalCostYourBooking={TotalPrice + totalSum}
                            />
                            )
                  
                          case languageWords?.yourDetails:
                            return (
                              <UserDetailsSection
                              defaultLanguage={defaultLanguage}
                              values={values}
                              setField={setFieldValue}
                              errors={errors}
                              touched={touched}
                              totalCount={totalCount}
                              languageWords={languageWords}
                              reservType={{...SelectedEventOrStdResType,...reservType}}
                              selectedDate={selectedDate}
                              time={time}
                              adult={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.adult}
                              child={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.child}
                              kid={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.kid}
                              baby={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.baby}
                              toddler={guestCounts[SelectedEventOrStdResType?.idreservationtype]?.toddler}
                              selectedExtraProduct={selectedExtraProduct}
                              transactionDetails={transactionDetails}
                              transactionPrice={
                                transactionDetails?.pricePerReservation
                              }
                              excludingVat={TOTAL_INCLUSIVE_VAT - TOTAL_VAT- transactionDetails?.pricePerReservation}
                              totalVat={TOTAL_VAT}
                              totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                              totalCostYourBooking={TotalPrice + totalSum}
                              GuestDetailsData={GuestDetailsData}
                              extraFieldsData={extraFieldsData}
                              setAddFields={setAddFields}
                              setGuestFields={setGuestFields}
                            />
                            );

                          case languageWords?.ConfirmandPay || "Confirm":
                            return <ConfirmandPay />;

                          default:
                            return <div>No page found</div>;
                        }
                      })()}
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        mt: 1,
                        pb: 10,
                      }}
                    >
                      <Button
                      startIcon={<ArrowBackIosTwoToneIcon />}
                        variant="contained"
                        //  disabled={activeStep === 1}
                        onClick={handleBack}
                        sx={{
                          mr: 1,
                          backgroundColor: theme?.details?.backButtonBgColor,
                          color: theme?.details?.backButtonTextColor,
                          "&:hover": {
                            backgroundColor:
                              theme?.details?.backButtonBgColorHover,
                            color: theme?.details?.backButtonTextColorHover,
                          },
                        }}
                      >
                    
                      </Button>
                      <Box sx={{ flex: "1 1 auto" }} />
                      {activeStep !== 4 && (
                        <Button
                        startIcon={
                          steps[activeStep] === languageWords?.yourDetails ? <CreditScoreIcon />:   <ArrowForwardIosTwoToneIcon />

                         }
                          onClick={() => {
                            if (
                              steps[activeStep] === languageWords?.yourDetails
                            ) {
                              if (Object.keys(errors).length == 0) {
                                creatBookingReservation();
                              }

                              // Submit the form when on step 3
                            } else {
                              handleNext(); // Proceed to the next step otherwise
                            }
                          }}
                          type={
                            steps[activeStep] === languageWords?.yourDetails
                              ? "submit"
                              : "button"
                          }
                          sx={{
                            mr: 1,

                            backgroundColor:
                              steps[activeStep] === languageWords?.yourDetails
                                ? reservType?.totalCost > 0
                                  ? theme?.details?.confirmBgColor
                                  : theme?.details?.nextButtonBgColor
                                : theme?.details?.nextButtonBgColor,
                            // color:theme?.details?.nextButtonTextColor,
                            color:
                              steps[activeStep] === languageWords?.yourDetails
                                ? reservType?.totalCost > 0
                                  ? theme?.details?.confirmTextColor
                                  : theme?.details?.nextButtonTextColor
                                : theme?.details?.nextButtonTextColor,
                            "&:hover": {
                              backgroundColor:
                                theme?.details?.nextButtonBgColorHover,
                              color: theme?.details?.nextButtonTextColorHover,
                            },
                          }}
                          disabled={
                            Object.keys(errors).length != 0 &&
                            steps[activeStep] === languageWords?.yourDetails
                          }
                        >
                          {/* <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <img src={nexticon} alt="next-img" />
                            {isLoading ? (
                              <CircularProgress
                                size="20px"
                                sx={{ color: "#fff" }}
                              />
                            ) : steps[activeStep] ===
                              languageWords?.yourDetails ? (
                              reservType?.totalCost > 0 ? (
                                languageWords?.ConfirmandPay
                              ) : (
                                languageWords?.Confirm
                              )
                            ) : (
                              languageWords?.Next
                            )}
                          </Box> */}
                          {
                                        isLoading ? <CircularProgress size={20} />:  steps[activeStep] === languageWords?.yourDetails && !isNaN(TOTAL_INCLUSIVE_VAT) ?
                                        `€ ${format_Number(parseFloat(TOTAL_INCLUSIVE_VAT).toFixed(2))}` : null
                                      }
                        </Button>
                      )}
                    </Box>
                  </React.Fragment>
                )}
              </div>
              {/* </Paper> */}
            </Box>
          </Box>
        )}
      </Formik>
      <Box sx={{ width: 500 }}>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClosebar}
          message="Reservation creation Unsuccessful"
          key={vertical + horizontal}
        />
      </Box>
    </>
  );
}
